import React, { Component } from 'react';

import ReactHtmlParser from 'react-html-parser';
import { Accordion } from 'semantic-ui-react';
import styled from 'react-emotion';
import i18next from 'i18next';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';

import AccordionMainList from '~/modules/ecommerceCoreUI/components/listViewLayout/itemsListFilter/FilterStyle';
import { Label } from '~/modules/coreUI/components/basic/Labels';

import Specifications from './productTabs/Specifications';
import SellingShops from './productTabs/SellingShops';

const AccordionContainer = styled(AccordionMainList)`
  .accordion.ui {
    padding: unset;
    border: unset;
    .title {
      padding: ${props => props.theme.paddings.large}px 0;

      font-size: ${props => props.theme.fonts.sizes.large}px;
      :before {
        font-size: ${props => props.theme.fonts.sizes.large}px;
      }
    }
    .content.active {
      max-height: unset;
      background-color: ${props => props.theme.colors.named.extraLightGrey};
    }
  }
`;

class ProductAccordion extends Component {
  state = { activeIndex: 0 };

  getPanels = (props) => {
    const {
      description, specifications, fromShops, brand, madeIn, onShopsLoaded, hasSpecs, weight, dimensions,
    } = props;
    const panels = [
      {
        title: 'Descriptions',
        content: {
          key: 'description_accordion',
          content: description ? ReactHtmlParser(description) : <Label>No Available Description</Label>,
        },
      },
      {
        title: 'Specifications',
        content: {
          key: 'specifications_accordion',
          content: (hasSpecs) ? (
            <Specifications
              specifications={specifications}
              madeIn={madeIn}
              brand={brand}
              weight={weight}
              dimensions={dimensions}
            />
          ) : <Label>No Available Specifications</Label>,
        },
      },
    ];

    if (!fromShops) {
      panels.unshift({
        title: i18next.t('ecommerceCoreUI:Product.sellingShops.title'),
        content: {
          key: 'shops_accordion',
          content: <SellingShops onShopsLoaded={onShopsLoaded} />,
        },
      });
    }

    return panels;
  };

  handleTitleClick = (e, itemProps) => {
    const { index } = itemProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  render = () => {
    const { activeIndex } = this.state;
    return (
      <AccordionContainer>
        <Accordion
          activeIndex={activeIndex}
          panels={this.getPanels(this.props)}
          onTitleClick={this.handleTitleClick}
          fluid
        />
      </AccordionContainer>
    );
  };
}

export default withMedia(ProductAccordion);
